import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PicRightOutlinedSvg from "@ant-design/icons-svg/es/asn/PicRightOutlined";
import AntdIcon from "../components/AntdIcon";
var PicRightOutlined = function PicRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PicRightOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PicRightOutlined.displayName = 'PicRightOutlined';
}
export default /*#__PURE__*/React.forwardRef(PicRightOutlined);